import Sheet from "react-modal-sheet";
import { css, styled } from "styled-components";

export const StyledSheet = styled(Sheet)<{ $height?: number }>`
  ${({ $height }) =>
    $height &&
    css`
      height: ${$height}px;
    `}
  .react-modal-sheet-container {
    border-radius: 1rem 1rem 0rem 0rem !important;
    background-color: ${({ theme }) => theme.colors.surfaceTertiary} !important;
    & > div {
      &:first-child {
        position: absolute !important;
        top: -20px;
      }
    }
  }

  .react-modal-sheet-header {
    height: 20px !important;
  }

  .react-modal-sheet-backdrop {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }

  .react-modal-sheet-drag-indicator {
    background-color: ${({ theme }) => theme.colors.surfaceTertiary} !important;
  }
`;

export const SheetTitle = styled.div`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 122.222%;
`;

export const SheetDescription = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
`;
